import { normalizePublicPath } from "@logscord/public-site/core";
import LocaleEN from "./locales/en-US.json" with { type: "json" };
import LocaleFR from "./locales/fr-FR.json" with { type: "json" };
export const DefaultLocale = "en-US";
export const PublicLocales = [
    {
        code: "en",
        locale: "en-US",
    },
    {
        code: "fr",
        locale: "fr-FR",
    },
];
const PublicLocaleByCode = new Map(PublicLocales.map((locale) => [locale.code, locale.locale]));
const PublicLocaleCodeByLocale = new Map(PublicLocales.map((locale) => [locale.locale, locale.code]));
function buildLocale(obj, store) {
    const output = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value && typeof value === "object" && value.constructor === Object) {
            Object.assign(output, buildLocale(value, store));
            continue;
        }
        if (typeof value === "string")
            output[key] = value.replace(/{{([^}]+)}}/g, (str, name) => {
                const properties = name.split(".");
                let current = store;
                for (const property of properties) {
                    if (!current || typeof current !== "object")
                        return str;
                    current = current[property];
                }
                return typeof current === "string" || typeof current === "number"
                    ? current.toString()
                    : str;
            });
    }
    return output;
}
const Locales = {
    "en-US": buildLocale(LocaleEN, {}),
    "fr-FR": buildLocale(LocaleFR, {}),
};
export { normalizePublicPath };
export function normalizeSupportedLocale(value) {
    if (typeof value !== "string")
        return DefaultLocale;
    const normalized = value.toLowerCase();
    const primary = normalized.split("-")[0] ?? "";
    return PublicLocaleByCode.get(primary) ?? DefaultLocale;
}
export function getPublicLocaleCodeFromLocale(locale) {
    return PublicLocaleCodeByLocale.get(locale) ?? "en";
}
export function formatLocale(lang, key, ...args) {
    const locale = normalizeSupportedLocale(lang);
    const str = Locales[locale]?.[key] || Locales["en-US"][key];
    if (!str)
        return key;
    return args.length
        ? str.replace(/\$([0-9]+)/g, (group, index) => args[parseInt(index) - 1]?.toString() ?? group)
        : str;
}
export function getPublicLocaleFromPath(path) {
    const [, firstSegment] = normalizePublicPath(path).split("/");
    if (!firstSegment)
        return null;
    return PublicLocaleByCode.get(firstSegment.toLowerCase()) ?? null;
}
export function removePublicLocalePrefix(path) {
    const normalizedPath = normalizePublicPath(path);
    const [, firstSegment] = normalizedPath.split("/");
    if (!firstSegment || !PublicLocaleByCode.has(firstSegment.toLowerCase()))
        return normalizedPath;
    const withoutPrefix = normalizedPath.slice(firstSegment.length + 1);
    return withoutPrefix.startsWith("/")
        ? withoutPrefix || "/"
        : `/${withoutPrefix}`;
}
export function withPublicLocalePrefix(path, localeCode) {
    const normalizedPath = normalizePublicPath(path);
    const suffix = normalizedPath === "/" ? "" : normalizedPath;
    return `/${localeCode}${suffix}`;
}
function parseAcceptLanguageQuality(value) {
    const quality = value
        .split(";")
        .find((part) => part.trim().startsWith("q="))
        ?.split("=")[1];
    if (!quality)
        return 1;
    const parsed = Number.parseFloat(quality);
    return Number.isFinite(parsed)
        ? parsed
        : 0;
}
export function detectLocaleFromAcceptLanguage(header) {
    const value = Array.isArray(header)
        ? header.join(",")
        : header;
    if (!value)
        return DefaultLocale;
    const candidates = value
        .split(",")
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry, index) => ({
        index,
        quality: parseAcceptLanguageQuality(entry),
        locale: normalizeSupportedLocale(entry.split(";")[0]),
    }))
        .sort((left, right) => (right.quality - left.quality || left.index - right.index));
    return candidates[0]?.locale ?? DefaultLocale;
}
//# sourceMappingURL=index.js.map